<template>
  <!-- config.options -->
  <div class="radio-controls">
    <div v-bind:style="{marginBottom: '0.75rem', marginTop: '0.75rem'}" class="option" v-for="(control, i) in config.options" :key="i">
      <input
        class="radio"
        type="radio"
        :name="radioName"
        :id="`${radioName}_${i}`"
        :value="control.value"
        @change="$emit('input', control.value)"
      />
      <label :for="`${radioName}_${i}`" class="label label--inline">
        {{ control.label }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true
    },
    config: {
      required: true
    }
  },
  data() {
    return {
      radioName: Math.random()
        .toString(36)
        .substr(2, 5),
      mb: 0.75
    };
  },
  methods: {}
};
</script>
